import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useDialogStore = defineStore('dialog', () => {
  const isOpen = ref(false);
  const text = ref<{
    title?: string;
    actionBtn: string;
    content?: string;
    closeBtn?: string;
    contentNeedCenter?: boolean;
    width?: string;
  }>({
    content: '',
    actionBtn: '',
    contentNeedCenter: false
  });
  const resolveAction = ref<undefined | null | (() => void)>(null);
  const resolveClose = ref<undefined | null | (() => void)>(null);
  const closeOnClickModal = ref<boolean>(true);
  const closeOnPressEscape = ref<boolean>(true);
  const keepAlive = ref(false); //於第一個dialog開啟，最後一個關閉
  const disableActionBtn = ref<boolean>(false);

  return {
    isOpen,
    text,
    resolveAction,
    resolveClose,
    closed,
    closeOnClickModal,
    closeOnPressEscape,
    keepAlive,
    disableActionBtn
  };
});
